import React, { useState } from 'react'
import { buildImageObj } from '../lib/helpers'
import { imageUrlFor } from '../lib/image-url'
import BlockContent from './block-content'
import styled from 'styled-components'

import YouTube from './youtube'
import NextPrev from './nextprev'
import ContentTag from './content-tag'
import Button from './button'

import { MdAccessTime, MdPeopleOutline } from 'react-icons/md';
import { FaCarrot } from 'react-icons/fa';
import { AiFillPicture, AiOutlinePicture } from 'react-icons/ai';

const Details = styled.section`
  max-width: 600px;
  display: flex;
  flex-direction: column;
`

const RecipeArticle = styled.article`

  #header {
    display: grid;
    grid-template-columns: minmax(60px, auto) 2fr 3fr minmax(60px, auto);
    grid-gap: 30px;
    background: #ffebde;

    #info {
      grid-column: 2;
      display: flex;
      flex-direction: column;
      justify-content: center;

      #description {
        max-width: 500px;
        min-width: 250px;
        font-size: 1.2em;
      }
    }

    img {
      width: 100%;
      object-fit: cover;
    }

    padding: 30px 0;

    @media only screen and (max-width: 800px) {
      grid-template-columns: minmax(30px, auto) 1fr minmax(30px, auto);
      > * {
        grid-column: 2 !important;
      }
    } 
  }

  #image-controls {
    grid-row: 1;
    grid-column: 4;
    border-left: 1px solid #dfdfdf;

    @media only screen and (max-width: 800px) {
      border: 0;
      grid-row: 2;
    }

    display: flex;
    flex-direction: column;

    button {
      align-self: center;
      justify-self: center;
    }
  }

  #video {
    > * {
      ${({ show }) => !show && 'margin:0;padding:0;'};
    }
    iframe {
      display: ${({ show }) => show ? 'block' : 'none'};
    }
  }



  #recipe {
    padding: 30px 0px;
    display: grid;
    grid-template-columns: minmax(60px, auto) 2fr 4fr 2fr minmax(60px, auto);
    grid-gap: 30px;
   
    @media only screen and (max-width: 800px) {
      grid-template-columns: minmax(30px, auto) 1fr minmax(30px, auto);
      > * {
        grid-column: 2 !important;
      }

      #ingredients {
        border-bottom: 1px solid #dfdfdf;
        border-top: 1px solid #dfdfdf;
        padding: 30px 0px;
        border-right: 0px;
      }
    } 
    
    h2 {
      font-size: 1em;
      text-transform: uppercase;
      margin-bottom: .5em;
    }
  }

  #ingredients {
    grid-column: 2;
    width: 100%;
    border-right: 1px solid #dfdfdf;

    ul {
      list-style: none;
      padding: 0; margin: 0;
    }
  }

  #steps {
    grid-column: 3;

    h3 {
      font-size: 1em;
      text-transform: uppercase;
      margin-top: 1em;
    }

    p {
      padding: 0;
      margin: 1em 0;
    }
  }

  @media only screen and (max-width: 800px) {
    #steps {
      grid-column: 2;
    }

    #ingredients {
      grid-column: 2;
    }
  
    
  }
`

const Steps = styled.ol`
  margin: 0;
  padding: 0;
  img {
    display: ${({ show }) => show ? 'block' : 'none'};
  }
`

const Step = styled.li`
  list-style:none;
  width: 100%;
  img {
    width: 100%;
  }
`

function Recipe(props) {
  const { title, ingredients, servings, _rawPreparation, _rawDescription, mainImage, time, byproduct, slug, toc, video } = props
  const [show, toggleShow] = useState(true);

  return (
    <RecipeArticle className="framed" show={show}>
      <NextPrev slug={slug} toc={toc} />

      <header id="header">
        <section id="info">
          <ContentTag type="Oppskrift" />
          <h1>{title}</h1>
          <div id="description">
            {_rawDescription && <BlockContent blocks={_rawDescription || []} />}
          </div>
          <Details>
            {byproduct && <div><FaCarrot /> {`${byproduct}`}</div>}
            {time && <div><MdAccessTime /> {time}</div>}
            {servings && <div><MdPeopleOutline /> {servings} Porsjoner</div>}
          </Details>
        </section>
        {(props.mainImage && mainImage.asset) && (
          <img
            src={imageUrlFor(buildImageObj(mainImage))
              .width(1200)
              .height(Math.floor((9 / 16) * 1200))
              .fit('crop')
              .url()}
            alt={mainImage.alt}
          />
        )}
      </header>

      <section id="recipe">
        <section id="ingredients">
          <header><h2>Ingredienser</h2></header>
          <ul>
            {
              ingredients.map(ingredient => {
                const { amount, unit, name, _key } = ingredient
                return <li key={_key}>{`${amount} ${unit} ${name.toLowerCase()}`}</li>
              })
            }
          </ul>
        </section>

        <section id="image-controls">
            <Button onClick={() => toggleShow(!show)}>
              {show ?
                <><AiOutlinePicture /> Bilder av</> :
                <><AiFillPicture /> Bilder på</>
              }
            </Button>
          </section>

        <section id="steps">
          <header><h2>Slik gjør du</h2></header>

          {video && video.url &&
            <div id="video">
              <YouTube node={video} />
            </div>
          }

          <Steps show={show}>
            {
              _rawPreparation && _rawPreparation.map((step, index) => (
                <Step key={index}>
                  <h3>{`Steg ${index + 1}.`}</h3>
                  <p>{step.description}</p>
                  {
                    step.image && step.image.asset && ( 
                    <img
                      src={imageUrlFor(buildImageObj(step.image))
                        .width(1200)
                        .height(Math.floor((9 / 16) * 1200))
                        .fit('crop')
                        .url()}
                      alt={mainImage.alt}
                    />
                    )
                  }
                </Step>
              ))
            }
          </Steps>
        </section>

      </section >
    </RecipeArticle >
  )
}

export default Recipe
